module.exports = __webpack_public_path__ + "assets/img/shopLine-store.2b0c3b96.png";